import React, { Component } from 'react';
import { BrowserRouter, Route, Routes, Link } from "react-router-dom";
import Inicio from './inicio.js';
import LogIn from './logIn.js';
import ResetPassword from './ResetPassword.js';
import ChangePassword from './changePassword.js';
import TerminosYCondiciones from './terminosYCondiciones.js';
import ListaEmpresas from './listaEmpresas.js';
import ListaCertificados from './ListaCertificados.js';
import ToolMenu from './ToolMenu.js';
import CertificadosUsuario16 from "./standard16/CertificadosUsuario16.js";
import CertificadoDisplay16 from "./standard16/NftDisplay.js";
import QRCertificadoDisplay16 from "./standard16/QRNftDisplay.js";
import QRDPP from "./DPP/QRDPP.js";
import QRDPP16 from "./DPP/QRDPP16.js";
import QRCertificadoDisplay8 from "./standard8/QRNftDisplay.js";
import CertificadosUsuario8 from "./standard8/CertificadosUsuario8.js";
import CertificadoDisplay8 from "./standard8/NftDisplay.js";





// import Standard16CertificateGenerator from './standard16/nftGenerator.js';




// import PrivateKeyGenerator from './PrivateKeyGenerator.js';
// import ResetPassword from './ResetPassword.js';
// import './css/App.css';



class App extends Component {

  render() {
    return (
      
          <BrowserRouter>
           
            <Routes>
              <Route path='/' element={<Inicio />} />
              <Route path='/logIn' element={<LogIn />} />
              <Route path='/resetPassword' element={<ResetPassword />} />
              <Route path='/changePass' element={<ChangePassword />} />
              <Route path='/terminosYcondiciones' element={<TerminosYCondiciones />} />
              <Route path='/listaEmpresas' element={<ListaEmpresas />} />
              <Route path='/:nombreMarca/listaCertificados' element={<ListaCertificados />} />
              <Route path='/:nombreMarca/toolMenu' element={<ToolMenu />} />
              <Route path='/:nombreMarca/standard8/userCertificateList' element={<CertificadosUsuario8 />} />
              <Route path='/:nombreMarca/standard8/certificateDisplay' element={<CertificadoDisplay8/>} />
              <Route path='/:nombreMarca/standard8/QRValidation' element={<QRCertificadoDisplay8/>} />
              <Route path='/:nombreMarca/DPP/QRDPP' element={<QRDPP/>} />
              <Route path='/:nombreMarca/DPP16/QRDPP' element={<QRDPP16/>} />
              <Route path='/:nombreMarca/standard16/userCertificateList' element={<CertificadosUsuario16 />} />
              <Route path='/:nombreMarca/standard16/certificateDisplay' element={<CertificadoDisplay16/>} />
              <Route path='/:nombreMarca/standard16/QRValidation' element={<QRCertificadoDisplay16/>} />
              
          
              {/*
             
              
             
             
              
              <Route path='/:nombreMarca/standard16/certificateGenerator' element={<Standard16CertificateGenerator />} />
            
              <Route path='/:nombreMarca/:standardType/privateKeyGenerator' element={<PrivateKeyGenerator />} /> */}
            </Routes>
          </BrowserRouter>
     
    );
  }
}
export default App;